var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.465 2.5a1 1 0 01.832.445l.406.61A1 1 0 009.535 4H21a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V3.5a1 1 0 011-1h4.465zM12 8a.412.412 0 00-.215.06.366.366 0 00-.151.188l-.915 2.275-2.357.215a.41.41 0 00-.216.094.465.465 0 00-.12.186.4.4 0 00.113.444l1.785 1.62-.536 2.408a.37.37 0 00.015.247c.034.075.08.135.142.181.061.046.13.073.206.08a.36.36 0 00.227-.058L12 14.661l2.023 1.28a.36.36 0 00.226.057.402.402 0 00.206-.08.455.455 0 00.142-.18.37.37 0 00.015-.248l-.536-2.408 1.785-1.62a.407.407 0 00.114-.444.465.465 0 00-.121-.186.41.41 0 00-.216-.094l-2.357-.215-.915-2.275a.366.366 0 00-.151-.187A.412.412 0 0012 8z",
    fill: "currentColor"
  })));
}
SvgSelectionsFilled.displayName = 'SelectionsFilled';
export default SvgSelectionsFilled;